import { CalendarItem } from "../models/CalendarItem";
import { OccurrenceStatus } from "../../sessions/models/OccurrenceStatus";
import { toYmd } from "./calendar-range";

/**
 * A delivered occurrence whose attendance was never marked: it has members, it
 * is in the past, and no Visit was recorded. These are exactly the gaps that
 * silently under-bill the month-end draft, so the calendar surfaces them.
 * Cancelled occurrences are excluded — nothing was delivered to record.
 */
export const isAttendanceUnrecorded = (item: CalendarItem, today: Date): boolean =>
  item.status !== OccurrenceStatus.Cancelled &&
  item.inviteeCount > 0 &&
  item.visitCount === 0 &&
  item.date < toYmd(today);
